module.exports = __webpack_public_path__ + "img/welfare-btn-bg.a738533d.png";